import React, { useState, useEffect } from "react";
import { ListMusic } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/apiService";

const SleepSlot = () => {
  const navigate = useNavigate();
  const [slotList, setSlotList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 20;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchSlot();
    } else {
      navigate("/");
    }
  }, [navigate, offset]);

  const fetchSlot = async () => {
    try {
      const response = await apiService.fetchData("admin/sleep/content");
      if (response?.data) {
        setSlotList(response.data); // use the 'data' array directly
        setTotalCount(response.data.length); // count from data length
      }
    } catch (error) {
      console.error("Error fetching Slot:", error);
    }
  };

  const handlePlaylist = (slotId) => navigate(`/sleep/slot-playlist/${slotId}`);

  const totalPages = Math.ceil(totalCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;
  const renderPagination = () => {
    const pageButtons = [];
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) {
        pageButtons.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - halfRange);
      let endPage = Math.min(totalPages, currentPage + halfRange);

      if (startPage > 1) pageButtons.push(1);
      if (startPage > 2) pageButtons.push("...");

      for (let i = startPage; i <= endPage; i++) {
        pageButtons.push(i);
      }

      if (endPage < totalPages - 1) pageButtons.push("...");
      if (endPage < totalPages) pageButtons.push(totalPages);
    }

    return pageButtons.map((page, index) =>
      typeof page === "number" ? (
        <button
          key={index}
          className={`btn mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setOffset((page - 1) * limit)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="btn mx-1 disabled">
          {page}
        </span>
      )
    );
  };

  const paginatedData = slotList.slice(offset, offset + limit);

  return (
    <div className="container">
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <h4>Sleep</h4>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                  <tr>
                    <th style={{ width: "200px" }}>Content Name</th>
                    <th>Show Description</th>
                    <th style={{ width: "150px" }}>Action</th>
                  </tr>
              </thead>
              <tbody>
                {paginatedData.map((slot) => (
                  <tr key={slot.sleep_content_id}>
                    <td>{slot.title || "-"}</td>
                    <td>{slot.description || "-"}</td>
                    <td>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => handlePlaylist(slot.ContentToSlots?.[0]?.sleep_slot_id)}
                      >
                        <ListMusic size={14} className="me-2" />
                        Playlist
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <nav className="d-flex justify-content-center my-3">
          <button
            className="btn btn-outline-primary me-2"
            onClick={() => setOffset(offset - limit)}
            disabled={offset === 0}
          >
            «
          </button>
          {renderPagination()}
          <button
            className="btn btn-outline-primary ms-2"
            onClick={() => setOffset(offset + limit)}
            disabled={offset + limit >= totalCount}
          >
            »
          </button>
        </nav>
      </div>
    </div>
  );
};

export default SleepSlot;
